import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ArtboardFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M15.22 19.84H4.12V4.08H19.88V15.18L15.22 19.84ZM13.88 18.6L18.6 13.88H13.88V18.6Z" />
    </SvgIcon>
  );
});
